/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowBack: {
  name: 'arrow-back';
  data: string;
} = {
  name: 'arrow-back',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>`
};
